module.exports = __webpack_public_path__ + "static/media/body-background.a4edba24.png";